import { debounceTime, map, Observable, OperatorFunction, tap } from "rxjs";

export function bufferDebounceTime<T>(dueTime: number): OperatorFunction<T,T[]> {
	return (observable)=>new Observable(subscriber=>{
		let buffer:T[]=[];//buffer being inside the subscription is important so multiple subscribers don't share a buffer
		return observable
			.pipe(
				map(v=>{
					buffer.push(v);
					return buffer;
				}),
				debounceTime(dueTime),
				tap(()=>{
					buffer=[];
				}))
			.subscribe(subscriber);
	});
}

export function bufferUniqueDebounceTime<T>(dueTime: number): OperatorFunction<T,Set<T>> {
	return (observable)=>new Observable(subscriber=>{
		let buffer=new Set<T>;//buffer being inside the subscription is important so multiple subscribers don't share a buffer
		return observable
			.pipe(
				map(v=>{
					buffer.add(v);
					return buffer;
				}),
				debounceTime(dueTime),
				tap(()=>{
					buffer=new Set();
				}))
			.subscribe(subscriber);
	});
}
